/* React */
import React, { useEffect } from "react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/redux/store";

/* Thunks */
import { fetchTestData } from "src/redux/thunks/test-data/testDataThunk";

/* Utils */
import useChartLoadingScreen from "src/utils/hooks/useChartLoadingScreen";
import DataImportWrapper from "src/utils/wrapper/admin-dashboard-wrapper/data-import-wrapper/DataImportWrapper";

/* Components */
import CurrentDataHandler from "src/components/admin-dashboard/data-handler/current-data-handler/CurrentDataHandler";
import ImportDataHandler from "src/components/admin-dashboard/data-handler/import-data-handler/ImportDataHandler";

const TestDataHandler: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const testDataState = useSelector(
    (state: RootState) => state.testData
  );

  const { data, importedData, isLoading, modifiedAt } =
    testDataState;

  useEffect(() => {
    dispatch(fetchTestData());
  }, [dispatch]);

  useChartLoadingScreen(isLoading, modifiedAt);

  return (
    <DataImportWrapper>
      <CurrentDataHandler importedData={importedData} />
      <ImportDataHandler
        data={data}
        importedData={importedData}
      />
    </DataImportWrapper>
  );
};

export default TestDataHandler;
